module.exports = __webpack_public_path__ + "media/images/flags/16/Greenland-9401cf0f75a71813d2fc0ae77fd716a7.png";